import '../math/Graph.js';
import '../math/Shapes.js';
import { Matrix } from '../math/Matrix.js';

class Scale {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    toMatrix() {
        return Matrix.scaling(this.x, this.y);
    }
    toString() {
        return `scale(${this.x},${this.y})`;
    }
    invert() {
        return new Scale(1 / this.x, 1 / this.y);
    }
}

export { Scale };
